import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Zoom from "@material-ui/core/Zoom";
import Fab from "@material-ui/core/Fab";
import RefreshRoundedIcon from "@material-ui/icons/RefreshRounded";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing(8),
    right: theme.spacing(8),
    background: theme.palette.success.main,
    "&:hover": {
      background: theme.palette.success.dark,
    },
  },
  fabIcon: {
    color: theme.palette.common.white,
  },
}));

const RefreshButton = (props) => {
  const classes = useStyles();

  return (
    <Zoom in={props.showRefresh} unmountOnExit>
      <Fab className={classes.fab} onClick={(e) => props.refresh(e)}>
        <RefreshRoundedIcon className={classes.fabIcon} />
      </Fab>
    </Zoom>
  );
};

export default RefreshButton;
